import { render, staticRenderFns } from "./AssignWorkPeriodForm.vue?vue&type=template&id=18a94d48&scoped=true&"
import script from "./AssignWorkPeriodForm.vue?vue&type=script&lang=ts&"
export * from "./AssignWorkPeriodForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a94d48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
